import React, { forwardRef } from "react";

const Checkbox = forwardRef(({ className, checked, onCheckedChange, onChange, disabled, id, ...props }, ref) => {
  // Handle both onChange and onCheckedChange for compatibility
  const handleChange = (e) => {
    if (onChange) onChange(e);
    if (onCheckedChange) onCheckedChange(e.target.checked);
  };

  return (
    <div className="relative inline-flex items-center">
      <input
        type="checkbox"
        id={id}
        ref={ref}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={`h-4 w-4 rounded-sm border border-gray-200 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        {...props}
      />
      {checked && (
        <svg
          className="absolute pointer-events-none h-3.5 w-3.5 text-white left-[2px] top-[2px]"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </div>
  );
});

Checkbox.displayName = "Checkbox";

export { Checkbox };
